import axios from 'axios'
import { Message } from 'element-ui'

function extractErrorMessage(error) {
    const data = error.response && error.response.data
    if (!data) return null
    if (typeof data === 'string') {
        try {
            const parsed = JSON.parse(data)
            return parsed.message || parsed.error || null
        } catch (e) {
            return data
        }
    }
    return data.message || data.error || null
}

// 设置axios请求拦截器，添加Authorization头
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token && token !== 'null' && token !== 'undefined') {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 设置axios响应拦截器：401 登出；其它错误尽量展示后端 message（与 GlobalExceptionHandler 一致）
axios.interceptors.response.use(
    response => response,
    error => {
        const status = error.response && error.response.status
        if (status === 401) {
            const msg = extractErrorMessage(error)
            localStorage.removeItem('token')
            localStorage.removeItem('id')
            localStorage.removeItem('schoolId')
            localStorage.removeItem('username')
            localStorage.removeItem('role')
            localStorage.removeItem('realName')
            if (msg) {
                Message.error(msg)
            }
            window.location.href = '/login'
            return Promise.reject(error)
        }
        if (error.config && error.config.silentError) {
            return Promise.reject(error)
        }
        const serverMsg = extractErrorMessage(error)
        if (serverMsg) {
            Message.error(serverMsg)
        } else if (status >= 500) {
            Message.error('服务器错误，请稍后重试')
        }
        return Promise.reject(error)
    }
)

// 公共参数获取方式，可根据实际情况调整
function getCommonParams() {
    const adminId = localStorage.getItem('id')
    const schoolId = localStorage.getItem('schoolId')
    
    return {
        adminId: (adminId && adminId !== 'null' && adminId !== 'undefined') ? adminId : undefined,
        schoolId: (schoolId && schoolId !== 'null' && schoolId !== 'undefined') ? schoolId : undefined
    }
}

// 封装请求方法
export function request(config) {
    const commonParams = getCommonParams()
    // 合并公共参数到请求参数
    if (config.method === 'get') {
        const mergedParams = { ...commonParams, ...(config.params || {}) }
        // 过滤掉 null 和 undefined 的参数
        config.params = Object.keys(mergedParams).reduce((acc, key) => {
            if (mergedParams[key] !== null && mergedParams[key] !== undefined && mergedParams[key] !== '') {
                acc[key] = mergedParams[key]
            }
            return acc
        }, {})
    } else {
        // 如果是 FormData 或数组，不合并参数
        if (!(config.data instanceof FormData) && !Array.isArray(config.data)) {
            config.data = { ...commonParams, ...(config.data || {}) }
        }
    }
    return axios(config)
}

// 可选：快捷方法
export function get(url, params = {}, options = {}) {
    return request({ url, method: 'get', params, ...options })
}

export function post(url, data = {}, options = {}) {
    const commonParams = getCommonParams()
    // 如果 data 是数组，直接使用，不合并公共参数
    const mergedData = Array.isArray(data) ? data : { ...commonParams, ...data }
    return axios({
        url,
        method: 'post',
        data: mergedData,
        headers: { 'Content-Type': 'application/json' },
        ...options
    })
}

// 新增 put 方法，表单序列化
export function put(url, data = {}, options = {}) {
    const commonParams = getCommonParams()
    const mergedData = { ...commonParams, ...data }
    return axios({
        url,
        method: 'put',
        data: mergedData,
        headers: { 'Content-Type': 'application/json' },
        ...options
    })
}

// 新增 delete 方法，表单序列化
export function del(url, data = {}, options = {}) {
    const commonParams = getCommonParams()
    const mergedData = { ...commonParams, ...data }
    return axios({
        url,
        method: 'delete',
        data: mergedData,
        headers: { 'Content-Type': 'application/json' },
        ...options
    })
}

// 默认导出对象，用于 Vue.prototype.$http
const http = {
    request,
    get,
    post,
    put,
    del
}

export default http
